<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/moneyBack_claim',title:'回款管理'},{title:'回款认领'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-pieceIn3">
                    <div class="h-pieceInTitle3">
                        <h1>基本信息</h1>
                    </div>
                    <div class="h-pieceInCon3">
                        <div class="h-formLine h-mrb-38 money">
                            <el-form :inline="true" class="demo-ruleForm h-formbLine">
<!--                                <el-form-item label="银行名称" class="h-elformWrap-2">-->
<!--                                    <brselectlazy filterable category="BankCategory_agent" :v="this.result.receBank"-->
<!--                                                  disabled-->
<!--                                                  v-model="this.result.receBank"-->
<!--                                                  :clearable="true"-->
<!--                                    />-->
<!--                                </el-form-item>-->
                                <el-form-item label="汇款人" class="h-elformWrap-2">
                                    <el-input :value="this.result.remitterName" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="汇款银行" class="h-elformWrap-2">
                                    <el-input :value="this.result.receBank" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="银行入账金额" class="h-elformWrap-2">
                                    <el-input :value="this.result.receAmount" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="银行会计科目" class="h-elformWrap-2">
                                    <el-input :value="this.result.receBankNo" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="币种" class="h-elformWrap-2">
                                    <mdmselect category="YLCurrency" :v="this.result.receCurrency"
                                               v-model="this.result.receCurrency" disabled/>
                                </el-form-item>

<!--                                <el-form-item label="汇率" class="h-elformWrap-2">-->
<!--                                    <el-input :value="this.result.huilv" readonly></el-input>-->
<!--                                </el-form-item>-->

<!--                                <el-form-item label="可认领金额" class="h-elformWrap-2">-->
<!--                                    <el-input :value="this.result.balanceAmount" readonly></el-input>-->
<!--                                </el-form-item>-->
                                <el-form-item label="凭证编码" class="h-elformWrap-2">
                                    <el-input :value="this.result.receCertNumber" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="销售组织" prop="saleGroupCode" class="h-elformWrap-2 ">
                                    <brselect category="xiaoshou_zuzhi" :v="this.result.saleGroupCode" :showcode="true"
                                              v-model="this.result.saleGroupCode" disabled></brselect>
                                </el-form-item>
                                <!--                                <el-form-item label="汇款人常驻国家" class="h-elformWrap-2">-->
                                <!--                                    <el-input :value="this.result.countryCode" readonly></el-input>-->
                                <!--                                </el-form-item>-->
                            </el-form>
                        </div>
                    </div>
                </div>
                <div class="h-pieceIn3" v-if="!this.isBandOrders">
                    <div class="h-pieceInTitle3">
                        <h1>认领信息</h1>
                    </div>
                    <div class="h-pieceInCon3">
                        <div class="h-formLine h-mrb-38 money">
                            <el-form :model="q" :inline="true" class="demo-ruleForm h-formbLine" :rules="rules" ref="q">
                                <el-form-item label="经销商名称" class="h-elformWrap-2" prop="customerCode">
                                    <el-select filterable placeholder="请选择" v-model="q.customerCode"
                                               @change="queryUserCode">
                                        <el-option v-for="(item) in user"
                                                   :key="item.usercode"
                                                   :label="'['+item.usercode+']'+item.customerName1"
                                                   :value="item.usercode">
                                            <span style="float: left">{{ item.customerName1 }}</span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.usercode}}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
<!--                                <el-form-item label="销售组织" prop="saleGroupCode" class="h-elformWrap-2 ">-->
<!--                                    <brselect category="xiaoshou_zuzhi" :v="q.saleGroupCode" :showcode="true"-->
<!--                                              v-model="q.saleGroupCode" clearable @change="queryUserCode"></brselect>-->
<!--                                </el-form-item>-->
                                <!--                                <el-form-item label="认领币种" class="h-elformWrap-2" prop="claimCurrency">-->
                                <!--                                    <mdmselect category="YLCurrency" :v="q.claimCurrency"-->
                                <!--                                               v-model="q.claimCurrency"-->
                                <!--                                               :clearable="true"-->
                                <!--                                               :showcode="true"-->
                                <!--                                               @change="queryUserCode"/>-->
                                <!--                                </el-form-item>-->
                                <el-form-item label="认领金额" class="h-elformWrap-2 "
                                              prop="enterAmount">
                                    <el-input placeholder="请填写" v-model="q.enterAmount"
                                              @change="countCommission" @onblur="countCommission"></el-input>
                                </el-form-item>
                                <el-form-item label="手续费" class="h-elformWrap-2  shouxufei"
                                              prop="commission">
                                    <el-input placeholder="请填写" v-model="q.commission" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="汇款人常驻国家" class="h-elformWrap-2"  prop="countryCode">
                                    <brselectlazy filterable category="YLCountry_agent" :v="q.countryCode"
                                                  v-model="q.countryCode"
                                                  :clearable="true"
                                                  :showcode="true"
                                    />
                                </el-form-item>
                                <el-form-item label="交易附言" class="h-elformWrap-2 shouxufei" prop="tradeWay">

                                    <brselectlazy filterable category="jiaoyifuyan" :v="q.tradeWay"
                                                  v-model="q.tradeWay"
                                                  :clearable="true"
                                    />
                                </el-form-item>
                                    <el-form-item label="认领余额" class="h-elformWrap-2">
                                                    <el-input :value="this.q.balanceAmount" readonly></el-input>
                                                </el-form-item>
                                <el-form-item label="备注" class="h-elformWrap-2">
                                    <el-input v-model="q.remark"></el-input>
                                </el-form-item>
                                <el-form-item label="合同、发票、第三方汇款委托证明等资料" class="h-elformWrap-1" prop="upload">
                                    <brupload
                                            :refid="refid"
                                            :reftype="reftype"
                                            uploadflag
                                            delflag
                                    >
                                    </brupload>
                                </el-form-item>

                        </el-form>
                        </div>
                    </div>
                </div>
                <div class="h-pieceIn3" v-if="this.isBandOrders">
                    <div class="h-pieceInTitle3">
                        <h1>重复认领信息</h1>
                    </div>
                    <div class="h-pieceInCon3">
                        <div class="h-formLine h-mrb-38 money">
                            <el-form :model="q" :inline="true" class="demo-ruleForm h-formbLine" :rules="rules" ref="q">
                                <el-form-item label="经销商编码" class="h-elformWrap-2">
                                    <el-input :value="q.customerCode" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="经销商名称" class="h-elformWrap-2">
                                    <el-input :value="q.customerName" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="认领金额" class="h-elformWrap-2">
                                    <el-input :value="q.enterAmount" readonly></el-input>
                                </el-form-item>
                                <el-form-item label="手续费" class="h-elformWrap-2">
                                    <el-input :value="q.commission" readonly></el-input>
                                </el-form-item>

                                <el-form-item label="汇款人常驻国家" class="h-elformWrap-2" readonly prop="countryCode">
                                    <brselectlazy filterable category="YLCountry_agent" :v="q.countryCode"
                                                  :clearable="true"
                                                  :showcode="true"
                                                  disabled
                                    />
                                </el-form-item>
                                <el-form-item label="交易附言" class="h-elformWrap-2 shouxufei" prop="tradeWay">
                                    <brselectlazy filterable category="jiaoyifuyan" :v="q.tradeWay"
                                                  :clearable="true"
                                                  :showcode="true"
                                                  disabled
                                    />
                                </el-form-item>
                                <el-form-item label="认领余额" class="h-elformWrap-2">
                                    <el-input :value="this.result.balanceAmount" readonly></el-input>
                                </el-form-item>
                        </el-form>
                        </div>
                    </div>
                </div>
                <div class="h-pieceIn3" >
                    <div class="h-pieceInTitle3">
                        <h1>关联订单列表</h1>
                        <div class="h-pieceInTitle3">
                            <h1 style="color: red;">5月1日切换新资金系统，届时新获取的流水需审核后从新资金系统获取凭证号后才可选择认领订单</h1>
                        </div>
                    </div>
                    <div class="h-table h-mrt20">
                        <!--                        <el-form label-position="right" status-icon :rules="rules" :model="orders" ref="orders">-->
                        <el-table
                                ref="multipleTable"
                                :data="orders"
                                stripe
                                style="width: 100%"
                                @selection-change="selectOrder"
                        >
                            <el-table-column
                                    type="selection"
                                    width="55"
                                    label="全选"
                                    :selectable='selectInit'
                            >
                            </el-table-column>
                            <el-table-column
                                    fixed
                                    type="index"
                                    label="#"
                                    width="40">
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="订单编号"
                                    width="120">
                                <template slot-scope="scope">
                                    <el-link type="primary" @click="getOrderInfo(scope.row)">{{scope.row.sapCode}}</el-link>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="add2"
                                    label="SAP订单编号"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="cdate"
                                    label="下单时间"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="add5"
                                    label="开票时间"
                                    width="140">
                            </el-table-column>
                            <el-table-column
                                    prop="orderPrice"
                                    label="订单总额(元)"
                                    width="120">
                            </el-table-column>
                            <el-table-column
                                    prop="currencyCode"
                                    label="币种"
                                    width="80">
                            </el-table-column>
<!--                            <el-table-column-->
<!--                                    prop="exchange"-->
<!--                                    label="RMB汇率"-->
<!--                                    width="100">-->
<!--                            </el-table-column>-->
                            <el-table-column
                                    prop="claimMoney"
                                    label="认领金额(元)"
                            >
                                <template slot-scope="scope">
                                    <!--                                        <el-form-item :prop="'orders' + [scope.$index] + '.claimMoney'"-->
                                    <!--                                                      :rules="rules.claimMoney">-->
                                    <el-input v-if="scope.row.flag" v-model="scope.row.claimMoney" type="number"
                                               @change="changeClaimMoney(scope.row)"></el-input>
                                    <!--                                        </el-form-item>-->
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="orderPriceDhk"
                                    label="剩余未回款金额(元)"
                            >
                            </el-table-column>
                        </el-table>
                        <!--                        </el-form>-->
                        <div class="h-tableBInfo">
                            <div class="h-tableBInfowrap">
                                <span>认领总额</span>
                                <span>{{this.q.enterAmount}}元</span>
                            </div>
                            <div class="h-tableBInfowrap">
                                <span>认领余额</span>
                                <span :class="{changecolor:change===true}">{{this.restMoney}}元</span>
                            </div>
                            <div class="h-tableBInfowrap">
                                <el-button class=" h-bgwhite" @click="reSelectOrder">重新选择</el-button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div class="h-txtCenter h-mrt60"  >
                <el-button class="h-btn h-bBtn h-bgwhite" v-if="this.$route.query.backurl != undefined" @click="quxiao">返回</el-button>
                <!--未认领，未绑定订单-->
                <el-button class="h-btn h-bBtn h-bgblueQ2"   @click="claim('q')" :disabled="doNotClaim"
                           v-if="this.isBandOrders == false && this.$route.query.id != undefined && this.result.isClaimed  == 0">认领
                </el-button>
                <!--已认领-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="claimAgain" :disabled="doNotClaim"
                           v-if="this.isBandOrders == true  && this.result.isClaimed  == 1">认领
                </el-button>
                <!-- isClaimed=5 驳回  -->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="reClaim" :disabled="doNotClaim"
                           v-if="this.$route.query.id == undefined && this.result.isClaimed ==5">重新认领
                </el-button>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" width="80%" class="body_dilog">
            <el-table
                    ref="multipleTable"
                    :data="orderProcess"
                    stripe
                    style="width: 100%"
                    @selection-change="selectOrder"
            >
                <el-table-column
                        type="index"
                        label="#"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="sapCode"
                        label="订单号"
                        fixed
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>

                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        fixed
                        :show-overflow-tooltip="true"
                        width="160">
                    <template slot-scope="scope">
                        <div style="text-align: left;" :title="scope.row.soldToName">
                            {{scope.row.soldToName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="商品名称"
                        fixed
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;" :title="scope.row.materialName">
                            {{scope.row.materialName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="数量"
                        width="60">
                    <template slot-scope="scope">
                        <div style="text-align: right;" :title="scope.row.proNumber">
                            {{scope.row.proNumber}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="note"
                        label="备注"
                        :show-overflow-tooltip="true"
                        min-width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;" :title="scope.row.note">
                            {{scope.row.note}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="prodtype"
                        label="自产/OEM"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="商品编码"
                        width="110">
                    <template slot-scope="scope">
                        <div :title="scope.row.materialCode">
                            {{scope.row.materialCode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="订单状态"
                        width="100">
                    <template scope="scope">
                        {{scope.row.status|dictname('order_status')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderCategory"
                        label="订单类型"
                        :show-overflow-tooltip="true"
                        width="150">
                    <template scope="scope">
                        {{scope.row.orderCategory|dictname('xiaoshou_quyu') }}
                        {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="saleGroupCode"
                        label="销售组织"
                        :show-overflow-tooltip="true"
                        width="260">
                    <template scope="scope">
                        <div style="text-align: left;">
                            [{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="add3"
                        label="DN单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="waybillId"
                        label="物流单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="add2"
                        label="SO单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>

                <el-table-column
                        prop="add1"
                        label="信用检查状态"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template scope="scope">
                        {{scope.row.add1|dictname('xinyong_zhuangtai')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="iszhidan"
                        label="经销商类型"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.iszhidan|dictname('dailishang_leixing')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="soldToCode"
                        label="经销商编码"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="商品大类"
                        :show-overflow-tooltip="true"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="tejiashuoming"
                        label="特价描述"
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.tejiashuoming}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="sid"
                        label="特价版本号"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="orderProjectCode"
                        label="工程版本号"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="单价"
                        :show-overflow-tooltip="true"
                        width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.finalPrice}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="totalprice"
                        label="总价"
                        :show-overflow-tooltip="true"
                        width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.totalprice}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="orderNetWorth"
                        label="净收入/净价值"
                        :show-overflow-tooltip="true"
                        width="130">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.orderNetWorth}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种"
                        :show-overflow-tooltip="true"
                        width="70">
                    <template slot-scope="scope">
                        <div style="text-align: right;">
                            {{scope.row.currencyCode}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="shouyiarea"
                        label="收益区域"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.shouyiarea|dictname('YLRegion')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="shifouyidi"
                        label="是否异地"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.shifouyidi|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="soldToAreaName"
                        label="售达方区域"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="customerChannelCode"
                        label="销售渠道"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.customerChannelCode|dictname('sales_region')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="toCompanyname"
                        label="收货单位"
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.toCompanyname}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="contactName"
                        label="联系人"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="firsttelephone"
                        label="电话"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.firsttelephone}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="soldToAreaName"
                        label="地区"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>

                <el-table-column
                        prop="soldToName"
                        label="省市名称"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{ `${scope.row.toProvincesName || ''}${scope.row.toCityName || ''}`}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="toAddress"
                        label="详细地址"
                        :show-overflow-tooltip="true"
                        width="180">
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.toAddress}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="receivedTime"
                        label="预期收货时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <!--                <el-table-column-->
                <!--                        prop="sptgTime"-->
                <!--                        label="审核通过时间"-->
                <!--						:show-overflow-tooltip="true"-->
                <!--                        width="220">-->
                <!--                </el-table-column>-->
                <el-table-column
                        prop="sptgTime"
                        label="销售订单生成日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="fhdate"
                        label="安排发货时间"
                        :show-overflow-tooltip="true"
                        :key="Math.random()"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="delTime"
                        label="生成发货计划时间"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="wlyjfh"
                        label="计划发货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="wlyjdh"
                        label="计划到货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="delTime"
                        label="实际发货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="arrTime"
                        label="实际到货日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="nxEightTime"
                        label="客户签收日期"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="taxCode"
                        label="税分类编码"
                        :show-overflow-tooltip="true"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="bktxt"
                        label="纸质发票号"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="arStatus"
                        label="是否清账"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.arStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="billingStatus"
                        label="发票是否创建"
                        :show-overflow-tooltip="true"
                        width="120">
                    <template scope="scope">
                        {{scope.row.billingStatus|dictname('pgiStatus')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="disChannelCode"
                        label="分销渠道"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="add4"
                        label="系统发票号"
                        :show-overflow-tooltip="true"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="add5"
                        label="开票时间"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="ldate"
                        label="最后更新时间"
                        width="160"
                        :show-overflow-tooltip="true">
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>


</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        name: 'leftMenu',
        data() {
            return {
                huilv: '',
                currency: '',
                backurl:'',
                dialogFormVisible:false,
                rules: {
                    customerCode:[
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    customerName1: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    enterAmount: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    commission: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    countryCode: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    tradeWay: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    claimMoney: [
                        {required: true, message: '请填写必填项', trigger: 'blur'},
                    ],
                    claimCurrency:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                },
                isBandOrders: false,
                usercode: '',
                ordersRegional: [],
                refid: '',
                reftype: '回款认领-第三方回款委托证明',
                restMoney: null,
                res: {
                    receMark: null
                },
                balanceAmountFlg : false,
                claimParams: {
                    orderNoList: [],
                    userReceForeign: {
                        id: null,
                        remitterName: null,
                        receAmount: null,
                        receMark: null,
                        receCertNumber: null,
                        receBank: null,
                        receDate: null,
                        remitterCode: null,
                        areaCode: null,
                        commission: 0,
                        claimName: null,
                        claimCode: null,
                        claimPhone: null,
                        countryCode: null,
                        tradeWay: null,
                        enterAmount: null,
                    }
                },
                value: {},
                orders: [],
                orderProcess :[],
                q:
                    {
                        remark:null,
                        orderNoList:
                            null,
                        commission: 0,
                        claimPhone: null,
                        countryCode: null,
                        tradeWay: '1',
                        enterAmount: null,
                    }
                ,
                user: {}
                ,
                userOne: {
                    accountGroup: null,
                    appellation:
                        null,
                    cdate:
                        null,
                    cityStreetRoom:
                        null,
                    companyAddress:
                        null,
                    companyCode:
                        null,
                    contactCity:
                        null,
                    contactMobilePhone:
                        null,
                    country:
                        null,
                    cucode:
                        null,
                    cuname:
                        null,
                    customerName1:
                        null,
                    customerNumber:
                        null,
                    customerTitle:
                        null,
                    delflag:
                        null,
                    faxNumber:
                        null,
                    language:
                        null,
                    ldate:
                        null,
                    lucode:
                        null,
                    name1:
                        null,
                    partnerFlagBp:
                        null,
                    partnerFlagPy:
                        null,
                    partnerFlagSh:
                        null,
                    partnerFlagSp:
                        null,
                    phoneNumber:
                        null,
                    phoneNumber1:
                        null,
                    postalCode:
                        null,
                    region:
                        null,
                    searchTerm:
                        null,
                    streetRoom:
                        null,
                    taxCode:
                        null,
                    usercode:
                        null
                }
                ,
                result: {}
                ,
                //表单
                formInline: {
                    customerName: '',
                    date1:
                        '',
                    date2:
                        '',
                    date3:
                        '',
                    type:
                        ''
                },
                //表格
                multipleSelection: [],
                tableData2: [],
                //上传凭证
                fileList: [],
                doNotClaim: false,
                change: false,
                bscUserInfoAgentBasic: {
                    region: null,
                }
            }
        },
        created() {
            this.queryUser();
            if (this.$route.query.id == undefined) {
                this.refid = this.$route.query.ywid;
            } else {
                this.refid = this.$route.query.id;
            }
            this.backurl = "/"+this.$route.query.backurl;
            // debugger
        },
        methods: {
            changeClaimMoney(v) {


                if (0 > v.claimMoney || v.claimMoney == 0 || v.claimMoney == null) {
                    this.$confirm('认领金额必须大于0！', '提示', {
                        confirmButtonText: '确认',
                        type: 'warning'
                    }).then(() => {
                        for (var i = 0; i < this.orders.length; i++) {
                            if (this.orders[i].id == v.id) {
                                this.orders[i].claimMoney = null;
                            }
                        }
                        this.doNotClaim = false;
                    }).catch(() => {
                        this.doNotClaim = true;
                    })
                } else {
                    this.doNotClaim = false;
                    var useMoney = 0;
                    for (var i = 0; i < this.orders.length; i++) {
                        if (this.orders[i].id == v.id) {

                            if (this.ordersRegional[i].orderPriceDhk < v.claimMoney || v.claimMoney == 0) {
                                this.$confirm('认领金额应小于等于待回款金额,且不能为0', '提示', {
                                    confirmButtonText: '确认',
                                    type: 'warning'
                                }).then(() => {
                                    v.claimMoney = null;
                                    this.doNotClaim = false;
                                    return ;
                                }).catch(() => {
                                    v.claimMoney = null;
                                    this.doNotClaim = true;
                                    return ;
                                })
                            }else {
                                this.orders[i].orderPriceDhk = parseFloat(JSON.parse(JSON.stringify(this.ordersRegional[i].orderPriceDhk)) - v.claimMoney).toFixed(2);
                            }
                        }
                        if (this.orders[i].claimMoney != undefined) {
                            useMoney += parseFloat(this.orders[i].claimMoney);
                        }
                    }
                    console.log(useMoney, 'usemoney')
                    if((parseFloat(this.q.balanceAmount) - useMoney).toFixed(2) < 0){
                        this.$confirm('认领金额应小于等于待回款金额,且不能为0！', '提示', {
                            confirmButtonText: '确认',
                            type: 'warning'
                        }).then(() => {

                            this.doNotClaim = false;
                        }).catch(() => {
                            this.doNotClaim = true;
                        })
                    }else{
                        this.restMoney = (parseFloat(this.q.balanceAmount).toFixed(2) - parseFloat(useMoney).toFixed(2)).toFixed(2);
                    }
                }
            },
            reClaim() {
                console.log(this.claimParams, 'bbbbbbb')
                if (this.value.length === undefined || this.value.length === 0) {
                    if (this.isBandOrders == true) {
                        this.$message({
                            type: "error",
                            message: '必须选择认领订单！'
                        });
                        return;
                    }
                    //如果未选择任意订单，给个提示
                    this.$confirm('未选择任一订单认领，继续操作将会把回款金额储存到余额中, 是否继续?', '提示', {
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        console.log(this.value, "value")
                        this.claimParams.orderNoList = [];
                        for (var i = 0; i < this.value.length; i++) {
                            this.claimParams.orderNoList.push(this.value[i]);
                        }


                        this.claimParams.userReceForeign.id = this.result.id;
                        this.claimParams.userReceForeign.remark = this.q.remark;
                        this.claimParams.userReceForeign.commission = this.q.commission;
                        this.claimParams.userReceForeign.claimPhone = this.q.claimPhone;
                        this.claimParams.userReceForeign.countryCode = this.q.countryCode;
                        this.claimParams.userReceForeign.tradeWay = this.q.tradeWay;
                        this.claimParams.userReceForeign.enterAmount = this.q.enterAmount;
                        this.claimParams.userReceForeign.customerCode = this.q.customerCode;
                        this.claimParams.userReceForeign.customerName = this.q.customerName;
                        this.claimParams.userReceForeign.taskid = this.$route.query.taskid;
                        this.claimParams.userReceForeign.claimCurrency = this.q.claimCurrency;
                        this.claimParams.userReceForeign.saleGroupCode = this.q.saleGroupCode;
                        console.log(this.q, 'qqq')
                        console.log(this.claimParams, 'aaaaaa')
                        ss.moneyBackClaimService.claim(this.claimParams).then(rd => {
                            console.log(rd);
                            if (rd.f) {
                                this.$message({
                                    type: "success",
                                    message: rd.msg
                                });
                                this.$msg.alerts("提交成功！", () => {
                                    //刷新右上角的代办个数
                                    this.$store.dispatch("searchTasktotal")
                                    //跳转回系统的代办列表
                                    this.$router.push({path: '/personal/dealCenter'})
                                })
                            } else {
                                this.$message({
                                    type: "error",
                                    message: rd.msg
                                });
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消认领'
                        });
                    });
                } else {
                    console.log(this.value, "value")
                    this.claimParams.orderNoList = [];
                    for (var i = 0; i < this.value.length; i++) {
                        this.claimParams.orderNoList.push(this.value[i]);
                    }
                    this.claimParams.userReceForeign.id = this.result.id;
                    this.claimParams.userReceForeign.remark = this.q.remark;
                    this.claimParams.userReceForeign.commission = this.q.commission;
                    this.claimParams.userReceForeign.claimPhone = this.q.claimPhone;
                    this.claimParams.userReceForeign.countryCode = this.q.countryCode;
                    this.claimParams.userReceForeign.tradeWay = this.q.tradeWay;
                    this.claimParams.userReceForeign.enterAmount = this.q.enterAmount;
                    this.claimParams.userReceForeign.customerCode = this.q.customerCode;
                    this.claimParams.userReceForeign.customerName = this.q.customerName;
                    this.claimParams.userReceForeign.taskid = this.$route.query.taskid;
                    this.claimParams.userReceForeign.claimCurrency = this.q.claimCurrency;
                    this.claimParams.userReceForeign.saleGroupCode = this.q.saleGroupCode;
                    console.log(this.claimParams, 'cccccc')
                    ss.moneyBackClaimService.claim(this.claimParams).then(rd => {
                        console.log(rd);
                        if (rd.f) {
                            this.$message({
                                type: "success",
                                message: rd.msg
                            });
                            this.$msg.alerts("提交成功！", () => {
                                //刷新右上角的代办个数
                                this.$store.dispatch("searchTasktotal")
                                //跳转回系统的代办列表
                                this.$router.push({path: '/personal/dealCenter'})
                            })
                        } else {
                            this.$message({
                                type: "error",
                                message: rd.msg
                            });
                        }
                    })
                }
            },
            queryForeign(v) {
                ss.moneyBackforeignService.queryForeign(v).then(response => {
                    // console.log(response, 'gggggggggggg')
                    // this.result = response.obj;
                    // if (response.obj.isBandOrders == 1) {
                    //     this.isBandOrders = true;
                    //     this.q.enterAmount = response.obj.enterAmount;
                    // }

                    this.result = response.obj;
                    this.usercode = response.obj.customerCode;
                    this.q.receCurrency = response.obj.receCurrency;
                    this.q.saleGroupCode = response.obj.saleGroupCode;
                    // this.q = response.obj;
                    if (response.obj.isBandOrders == 1) {
                        this.isBandOrders = true;
                        this.q.enterAmount = response.obj.enterAmount;
                    }
                    //this.isBandOrders = true;
                    // debugger
                    // ss.moneyBackClaimService.orders(response.obj.customerCode, response.obj.receCurrency,response.obj.saleGroupCode).then(rd => {
                    //     this.orders = rd;
                    //     this.ordersRegional = JSON.parse(JSON.stringify(rd));
                    //     console.log(this.orders)
                    // })
                    // this.q.enterAmount = response.obj.enterAmount;
                    // this.countCommission();
                })
            },
            countCommission() {

                // ss.OrderMainService.getExchange({
                //     fromCurrency: this.result.receCurrency,
                //     toCurrency: this.result.claimCurrency==null?this.result.receCurrency:this.result.claimCurrency
                // }).then(rd => {
                //     console.log(rd, '汇率')
                //     this.huilv = rd;
                //     this.q.commission =this.q.enterAmount - parseFloat(this.result.balanceAmount) * parseFloat(this.huilv).toFixed(2);
                //     // this.restMoney = parseFloat(this.q.enterAmount) * parseFloat(this.huilv).toFixed(2);
                //     this.restMoney = this.q.enterAmount
                // })
                // console.log(this.restMoney, '余额')
                this.q.commission =parseFloat(this.q.enterAmount - parseFloat(this.result.receAmount)).toFixed(2);
                // this.restMoney = parseFloat(this.q.enterAmount) * parseFloat(this.huilv).toFixed(2);
                // debugger
                this.restMoney = this.q.balanceAmount ==undefined || this.q.balanceAmount == null ? this.q.enterAmount:this.q.balanceAmount;
                if(this.q.balanceAmount ==undefined){
                    this.balanceAmountFlg = true
                }
                if(this.balanceAmountFlg){
                    this.q.balanceAmount = this.q.enterAmount;
                }

            },
            countCommissionYufu() {
                ss.OrderMainService.getExchange({
                    fromCurrency: this.result.receCurrency,
                    toCurrency: this.result.claimCurrency==null?this.result.receCurrency:this.result.claimCurrency
                }).then(rd => {
                    console.log(rd, '汇率')
                    this.huilv = rd;
                    this.q.commission =this.q.enterAmount - parseFloat(this.result.balanceAmount) * parseFloat(this.huilv).toFixed(2);

                    this.restMoney = parseFloat(this.q.enterAmount) * parseFloat(this.huilv).toFixed(2);
                })
                console.log(this.restMoney, '余额')
            },
            queryUser() {
                console.log(this._user, "当前登录人")
                this.bscUserInfoAgentBasic.region = this._user.area;
                ss.moneyBackClaimService.query(this.bscUserInfoAgentBasic).then(rd => {
                    console.log(rd);
                    this.user = rd;
                })
            },
            queryUserCode(v) {
                for (var i = 0; i < this.user.length; i++) {
                    if (this.user[i].usercode == v) {
                        //this.q.soldToCode = this.user[i].usercode;
                        this.q.customerName = this.user[i].customerName1;
                        this.q.claimPhone = this.user[i].phoneNumber;
                        this.usercode = this.user[i].usercode;
                    }
                }
                //查询客户对应的订单
                this.currency = this.q.receCurrency;
                this.saleGroupCode = this.q.saleGroupCode;
                // debugger
                ss.moneyBackClaimService.orders(this.usercode,this.currency,this.saleGroupCode).then(rd => {
                    this.orders = rd;
                    this.ordersRegional = JSON.parse(JSON.stringify(rd));
                    console.log(this.orders)
                })


                this.countCommission();
            },
            //选择认领订单方法
            // selectOrder(v) {
            //     console.log(v, '单条订单信息')
            //     this.value = v;
            //     if (this.value.length == 0) {
            //         for (var i = 0; i < this.orders.length; i++) {
            //             this.orders[i].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[i].orderPriceDhk));
            //             this.orders[i].flag = false;
            //             // this.orders[i].claimMoney = '0';
            //         }
            //     } else {
            //         for (var i = 0; i < this.value.length; i++) {
            //             for (var j = 0; j < this.orders.length; j++) {
            //                 if (this.value[i].id != this.orders[j].id) {
            //                     this.orders[j].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[j].orderPriceDhk));
            //                     this.orders[j].flag = false;
            //                     // this.orders[j].claimMoney = 0;
            //                 }
            //             }
            //         }
            //     }
            //     this.change = false;
            //     this.doNotClaim = false;
            //     this.restMoney = this.q.enterAmount;
            //     var useMoney = 0;
            //     for (var i = 0; i < this.value.length; i++) {
            //         if (this.value[i].claimMoney != undefined){
            //             useMoney += parseFloat(this.value[i].claimMoney);
            //         }
            //         for (var j = 0; i < this.orders.length; i++) {
            //             if (this.value[i].id == this.orders[j].id) {
            //                 if (this.value[i].claimMoney != undefined){
            //                     this.orders[j].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[j].orderPriceDhk)) - this.value[i].claimMoney;
            //                 }
            //             }
            //         }
            //         // v[i].claimMoney = 0;
            //         v[i].flag = true;
            //     }
            //     // if (this.restMoney - useMoney <= 0) {
            //     //     v[v.length - 1].orderPriceDhk = v[v.length - 1].orderPriceDhk - (this.restMoney - useMoney + v[v.length - 1].orderPriceDhk);
            //     //     this.restMoney = 0;
            //     // } else {
            //     this.restMoney = this.restMoney - useMoney;
            //     // }
            //     console.log(useMoney)
            //     if (this.restMoney < 0) {
            //         this.doNotClaim = true;
            //         this.change = true;
            //         this.$message({
            //             type: "warning",
            //             message: '认领余额已不足，无法完成认领！'
            //         });
            //     }
            //     console.log(this.value, "aaaaaaaa")
            // },
            selectOrder(v) {
                console.log(v, '单条订单信息')
                console.log(this.orders, 'this.orders')
                //被选中的订单可以编辑回款金额
                for (var i = 0; i < v.length; i++) {
                    v[i].flag = true;
                }
                //未被选中的订单不可修改回款金额
                for (var j = 0; j < this.orders.length; j++) {
                    var count = 0;
                    for (var a = 0; a < v.length; a++) {
                        if (this.orders[j].id != v[a].id) {
                            count += 1;
                        }
                    }
                    //没被选择的订单可以进行的操作
                    if (count == v.length) {
                        this.orders[j].flag = false;
                        this.orders[j].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[j].orderPriceDhk));
                    }
                }
                //刷新待回款金额
                for (var b = 0; b < v.length; b++) {
                    for (var c = 0; c < this.ordersRegional.length; c++) {
                        if (v[b].id == this.ordersRegional[c].id) {
                            if (v[b].claimMoney == undefined) {
                                v[b].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[c].orderPriceDhk));
                            } else {
                                v[b].orderPriceDhk = JSON.parse(JSON.stringify(this.ordersRegional[c].orderPriceDhk)) - v[b].claimMoney;
                            }

                        }
                    }
                }
                //刷新认领余额
                var useMoney = 0;
                for (var d = 0; d < v.length; d++) {
                    if (v[d].claimMoney != undefined && v[d].claimMoney != '') {
                        useMoney += parseFloat(v[d].claimMoney);
                    }
                }
                this.restMoney = parseFloat(this.q.balanceAmount).toFixed(2) - parseFloat(useMoney).toFixed(2);
                this.restMoney = parseFloat(this.restMoney).toFixed(2);
                this.value = v;
            },
            reSelectOrder() {
                this.orders = JSON.parse(JSON.stringify(this.ordersRegional));
            },
            selectInit(row, index) {
                if (row.sapCode == ''|| row.sapCode == null || row.add2 == '' || row.add2 == null || (!this.isBandOrders && this.result.fromType =='fap')) {
                    return false;
                } else {
                    return true;
                }
            },

            claim(v) {
                this.$refs[v].validate((valid) => {
                    if (valid) {
                        console.log(this.claimParams, 'bbbbbbb')
                        // debugger
                        if(this.q.enterAmount < this.result.receAmount){
                            this.$message({
                                type: "error",
                                message: '认领金额不能小于银行回款金额！'
                            });
                            return;
                        }
                        if (this.value.length === undefined || this.value.length === 0) {
                            if (this.isBandOrders == true) {
                                this.$message({
                                    type: "error",
                                    message: '必须选择认领订单！'
                                });
                                return;
                            }
                            //如果未选择任意订单，给个提示
                            this.$confirm('未选择任一订单认领，继续操作将只会绑定认领金额到客户, 是否继续?', '提示', {
                                confirmButtonText: '继续',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                console.log(this.value, "value")
                                this.claimParams.orderNoList = [];
                                for (var i = 0; i < this.value.length; i++) {
                                    this.claimParams.orderNoList.push(this.value[i]);
                                }
                                this.claimParams.userReceForeign.id = this.result.id;
                                this.claimParams.userReceForeign.remark = this.q.remark;
                                this.claimParams.userReceForeign.commission = this.q.commission;
                                this.claimParams.userReceForeign.claimPhone = this.q.claimPhone;
                                this.claimParams.userReceForeign.countryCode = this.q.countryCode;
                                this.claimParams.userReceForeign.tradeWay = this.q.tradeWay;
                                this.claimParams.userReceForeign.enterAmount = this.q.enterAmount;
                                this.claimParams.userReceForeign.customerCode = this.q.customerCode;
                                this.claimParams.userReceForeign.customerName = this.q.customerName;
                                this.claimParams.userReceForeign.taskid = this.$route.query.taskid;
                                this.claimParams.userReceForeign.claimCurrency = this.q.claimCurrency;
                                this.claimParams.userReceForeign.saleGroupCode = this.q.saleGroupCode;
                                console.log(this.claimParams, 'aaaaaa')
                                ss.moneyBackClaimService.claim(this.claimParams).then(rd => {
                                    console.log(rd);
                                    if (rd.f) {
                                        this.$message({
                                            type: "success",
                                            message: rd.msg
                                        });
                                        this.$router.push({path: this.backurl});
                                    } else {
                                        this.$message({
                                            type: "error",
                                            message: rd.msg
                                        });
                                    }
                                })
                            }).catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消认领'
                                });
                            });
                        } else {
                            console.log(this.value, "value")
                            this.claimParams.orderNoList = [];
                            for (var i = 0; i < this.value.length; i++) {
                                this.claimParams.orderNoList.push(this.value[i]);
                            }
                            if (this.isBandOrders == false) {
                                this.claimParams.userReceForeign.id = this.result.id;
                                this.claimParams.userReceForeign.remark = this.q.remark;
                                this.claimParams.userReceForeign.commission = this.q.commission;
                                this.claimParams.userReceForeign.claimPhone = this.q.claimPhone;
                                this.claimParams.userReceForeign.countryCode = this.q.countryCode;
                                this.claimParams.userReceForeign.tradeWay = this.q.tradeWay;
                                this.claimParams.userReceForeign.enterAmount = this.q.enterAmount;
                                this.claimParams.userReceForeign.customerCode = this.q.customerCode;
                                this.claimParams.userReceForeign.customerName = this.q.customerName;
                                this.claimParams.userReceForeign.taskid = this.$route.query.taskid;
                                this.claimParams.userReceForeign.claimCurrency = this.q.claimCurrency;
                                this.claimParams.userReceForeign.saleGroupCode = this.q.saleGroupCode;
                            } else {
                                this.claimParams.userReceForeign = this.result;
                            }
                            console.log(this.claimParams, 'cccccc')
                            ss.moneyBackClaimService.claim(this.claimParams).then(rd => {
                                console.log(rd);
                                if (rd.f) {
                                    this.$message({
                                        type: "success",
                                        message: rd.msg
                                    });
                                    this.$router.push({path: this.backurl});
                                } else {
                                    this.$message({
                                        type: "error",
                                        message: rd.msg
                                    });
                                }
                            })
                        }
                    } else {
                        return false;
                    }
                });
            },
            claimAgain() {

                if(this.result.fromType =='fap'){
                    this.$message({
                        type: "error",
                        message: '暂时无法认领！'
                    });
                    return;
                }

                if (!this.result.receCertNumber) {
                    this.$message({
                        type: "error",
                        message: '未获取到凭证编码请时候再试！'
                    });
                    return;
                }


                console.log(this.claimParams, 'bbbbbbb')
                if (this.value.length === undefined || this.value.length === 0) {
                    if (this.isBandOrders == true) {
                        this.$message({
                            type: "error",
                            message: '必须选择认领订单！'
                        });
                        return;
                    }

                    //如果未选择任意订单，给个提示
                    this.$confirm('未选择任一订单认领，继续操作将会把回款金额储存到余额中, 是否继续?', '提示', {
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        console.log(this.value, "value")
                        this.claimParams.orderNoList = [];
                        for (var i = 0; i < this.value.length; i++) {
                            this.claimParams.orderNoList.push(this.value[i]);
                        }

                        this.claimParams.userReceForeign.id = this.result.id;
                        this.claimParams.userReceForeign.commission = this.q.commission;
                        this.claimParams.userReceForeign.claimPhone = this.q.claimPhone;
                        this.claimParams.userReceForeign.countryCode = this.q.countryCode;
                        this.claimParams.userReceForeign.tradeWay = this.q.tradeWay;
                        this.claimParams.userReceForeign.enterAmount = this.q.enterAmount;
                        this.claimParams.userReceForeign.customerCode = this.q.customerCode;
                        this.claimParams.userReceForeign.customerName = this.q.customerName;
                        this.claimParams.userReceForeign.taskid = this.$route.query.taskid;
                        this.claimParams.userReceForeign.claimCurrency = this.q.claimCurrency;
                        this.claimParams.userReceForeign.saleGroupCode = this.q.saleGroupCode;
                        this.claimParams.userReceForeign.remark = this.q.remark;

                        console.log(this.claimParams, 'aaaaaa')
                        ss.moneyBackClaimService.claimAgain(this.claimParams).then(rd => {
                            console.log(rd);
                            if (rd.f) {
                                this.$message({
                                    type: "success",
                                    message: rd.msg
                                });
                                this.$router.push({path: this.backurl});
                            } else {
                                this.$message({
                                    type: "error",
                                    message: rd.msg
                                });
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消认领'
                        });
                    });
                } else {
                    for (var i = 0; i < this.value.length; i++) {
                        if(this.value[i].claimMoney === undefined){
                            this.$message({
                                type: "error",
                                message: '认领金额不能为空！'
                            });
                            return;
                        }

                    }
                    console.log(this.value, "value")
                    this.claimParams.orderNoList = [];
                    for (var i = 0; i < this.value.length; i++) {
                        this.claimParams.orderNoList.push(this.value[i]);
                    }
                    if (this.isBandOrders == false) {

                        this.claimParams.userReceForeign.id = this.result.id;
                        this.claimParams.userReceForeign.remark = this.q.remark;
                        this.claimParams.userReceForeign.commission = this.q.commission;
                        this.claimParams.userReceForeign.claimPhone = this.q.claimPhone;
                        this.claimParams.userReceForeign.countryCode = this.q.countryCode;
                        this.claimParams.userReceForeign.tradeWay = this.q.tradeWay;
                        this.claimParams.userReceForeign.enterAmount = this.q.enterAmount;
                        this.claimParams.userReceForeign.customerCode = this.q.customerCode;
                        this.claimParams.userReceForeign.customerName = this.q.customerName;
                        this.claimParams.userReceForeign.taskid = this.$route.query.taskid;
                        this.claimParams.userReceForeign.claimCurrency = this.q.claimCurrency;
                        this.claimParams.userReceForeign.saleGroupCode = this.q.saleGroupCode;
                    } else {
                        this.claimParams.userReceForeign = this.result;
                    }
                    console.log(this.claimParams, 'cccccc')
                    ss.moneyBackClaimService.claimAgain(this.claimParams).then(rd => {
                        console.log(rd);
                        if (rd.f) {
                            this.$message({
                                type: "success",
                                message: rd.msg
                            });
                            this.$router.push({path: this.backurl});
                        } else {
                            this.$message({
                                type: "error",
                                message: rd.msg
                            });
                        }
                    })
                }
            },
            quxiao() {
                //this.$router.back();
                this.$router.push({path: this.backurl});
            },
            getOrderInfo(v){
                this.dialogFormVisible = true
                ss.moneyBackClaimService.orderProcessPage({"sapCode":v.sapCode}).then(rd => {
                    console.log(rd);
                    this.orderProcess = rd
                })
            }
        },
        mounted() {
            if (this.$route.query.id == undefined) {
                this.queryForeign(this.$route.query.ywid);
                // debugger
            } else {
                ss.moneyBackforeignService.queryForeign(this.$route.query.id).then(response => {
                    this.result = response.obj;
                    this.usercode = response.obj.customerCode;
                    this.q = response.obj;
                    if (response.obj.isBandOrders == 1) {
                        this.isBandOrders = true;
                        //this.q.enterAmount = response.obj.enterAmount;
                    }
                    //this.isBandOrders = true;
                    ss.moneyBackClaimService.orders(response.obj.customerCode, response.obj.receCurrency,response.obj.saleGroupCode).then(rd => {
                        this.orders = rd;
                        this.ordersRegional = JSON.parse(JSON.stringify(rd));
                        console.log(this.orders)
                    })
                   // this.q.enterAmount = response.obj.enterAmount;
                    this.countCommission();

                })
            }
        }
    }
</script>

<style>
    .money .h-formbLine .el-form-item__label {
        width: 40%;
        text-align: right;
    }

    .money .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .money .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .money .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .money .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 11%;
    }

    .money .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 89%;
    }
</style>
